// material-ui
// import { Link, Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const AuthFooter = () => 
 (
//   <Stack direction="row" justifyContent="space-between">

//   </Stack>
<>
</>
)
export default AuthFooter;
